import { Link, Progress } from '@backstage/core-components';
import { Box, Typography } from '@material-ui/core';
import { useEffect, useState } from 'react';

export const HomePageRedirect = ({ redirectUrl }: { redirectUrl: string }) => {
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    if (countdown === 1) {
      window.location.replace(redirectUrl);
      return;
    }
    const timer = setTimeout(() => setCountdown(c => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown, redirectUrl]);

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100vh" style={{ background: 'linear-gradient(160deg, #0d2a5a 0%, #134187 50%, #1b2d45 100%)' }}>
      <Progress />
      <Typography variant="h1" style={{ color: '#36b3f6', marginTop: 24, fontSize: 72, fontWeight: 'bold' }}>
        {countdown}
      </Typography>
      <Typography variant="h6" style={{ color: '#FFF', marginTop: 20 }}>
        O endereço do Portal OLIMPIA mudou!
      </Typography>
      <Typography variant="body2" style={{ color: 'rgba(255,255,255,0.7)', marginTop: 8 }}>
        Você será redirecionado para{' '}
        <Link to={redirectUrl} style={{ color: '#36b3f6' }}>{redirectUrl}</Link>
      </Typography>
    </Box>
  );
};
